import { PackageType } from '../../Enums/PackageType'
import Offer from '../../Models/Offer'
import './OfferBox.css'

interface Props
{
	data: Offer,
	customerType: string
}

const OfferBox = (props: Props) =>
{
	function getPromoImage(){
		if (props.data?.package_type === PackageType.Promo) {
			return <img className="offer-promo-image" alt='' src='/assets/cockade.png' />
		}
	}

	return (
		<div className="offer-container" style={{ backgroundColor: props.data?.background_color }} >
			<img className="offer-image" alt='' src={`${props.data?.image_url}`} />
			{getPromoImage()}
			<div className="offer-text-container">
				<div className='offer-title'>{props.data?.ad_title}</div>
				<div className="offer-first-third-line">internet fino</div>
				<div className="offer-second-line">a <b style={{ color: props.data?.price_color }}>{props.data?.ad_speed}</b></div>
				<div className="offer-first-third-line">A</div>
				<div className="offer-fourth-line" style={{ color: props.data?.price_color }}>{props.data?.ad_price}</div>
				<div className="offer-subtitle">{props.data?.ad_subtitle}</div>
				<div className='offer-extras' style={{ color: props.data?.description_color }}>
					<div className='offer-extra'>{props.data?.ad_line_1}</div>
					<div className='offer-extra'>{props.data?.ad_line_2}</div>
					<div className='offer-extra'>{props.data?.ad_line_3}</div>
				</div>
			</div>
			<div className='offer-details-link-container'>
				<a className='offer-details-link' href={`${process.env.REACT_APP_SITE_URL}/contatti/`}>
					<button className='offer-white-button'>Contattaci</button>
				</a>
				<a className='offer-details-link' href={`/dettaglio-offerta/${props.data?.id}/${props.customerType}`}>
					scopri i dettagli
				</a>
			</div>
		</div>
	)
}

export default OfferBox
